module.exports = __webpack_public_path__ + "media/images/p-about/structure/structure-34d1c78a8f05ef60f2e05b5714fad0ca.svg";